/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubcategoryLookupDto
 */
export interface CreateSubcategoryLookupDto {
    /**
     * Unique sub-category code
     * @type {string}
     * @memberof CreateSubcategoryLookupDto
     */
    code: string;
    /**
     * Sub-category name in English
     * @type {string}
     * @memberof CreateSubcategoryLookupDto
     */
    nameEn: string;
    /**
     * Sub-category name in Arabic
     * @type {string}
     * @memberof CreateSubcategoryLookupDto
     */
    nameAr?: string;
    /**
     * Sub-category description
     * @type {string}
     * @memberof CreateSubcategoryLookupDto
     */
    description?: string;
    /**
     * Whether the sub-category is active
     * @type {boolean}
     * @memberof CreateSubcategoryLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof CreateSubcategoryLookupDto
     */
    sortOrder?: number;
    /**
     * Parent category lookup ID
     * @type {number}
     * @memberof CreateSubcategoryLookupDto
     */
    categoryLookupId: number;
}

/**
 * Check if a given object implements the CreateSubcategoryLookupDto interface.
 */
export function instanceOfCreateSubcategoryLookupDto(value: object): value is CreateSubcategoryLookupDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('categoryLookupId' in value) || value['categoryLookupId'] === undefined) return false;
    return true;
}

export function CreateSubcategoryLookupDtoFromJSON(json: any): CreateSubcategoryLookupDto {
    return CreateSubcategoryLookupDtoFromJSONTyped(json, false);
}

export function CreateSubcategoryLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubcategoryLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'categoryLookupId': json['categoryLookupId'],
    };
}

export function CreateSubcategoryLookupDtoToJSON(value?: CreateSubcategoryLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'categoryLookupId': value['categoryLookupId'],
    };
}

